import React from 'react';
// import { Card } from 'react-bootstrap';
// import CardDropdown from 'components/common/CardDropdown';
// import FalconCardHeader from 'components/common/FalconCardHeader';
import PropTypes from 'prop-types';
import Avatar, { AvatarGroup } from './Avatar';
import paths from 'routes/paths';

const ProjectStatistics = ({ projectUsers, setTableDetails, title }) => {
  return (
    // <Card className="h-100">
    //   <FalconCardHeader
    //     title="Project Statistics"
    //     titleTag="h6"
    //     endEl={<CardDropdown />}
    //   />
    // <Card.Body className="pt-0">
    <>
      <h5 className="mb-2 ">Nurse List</h5>
      <AvatarGroup
      // dense
      >
        {projectUsers.slice(0, 10).map(({ profileImage, name, id }) => {
          return (
            <Avatar
              src={profileImage && profileImage}
              key={id}
              name={name && name}
              size="2xl"
              className="border border-3 rounded-circle border-200"
              to={paths.nursd_profile(id, 'profile')}
            />
          );
        })}
        {projectUsers?.length >= 10 && (
          <Avatar
            name={`+${projectUsers?.length - 10}`}
            size="2xl"
            isExact
            className="border border-3 rounded-circle border-200 "
            onClick={() => setTableDetails({ title: title, view: true })}
          />
        )}
      </AvatarGroup>
    </>
    // </Card.Body>
    // </Card>
  );
};

ProjectStatistics.propTypes = {
  projectUsers: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      profileImage: PropTypes.string,
      name: PropTypes.string
    })
  ),
  setTableDetails: PropTypes.any,
  title: PropTypes.string
};

export default ProjectStatistics;
